import { render, staticRenderFns } from "./orderYbList.vue?vue&type=template&id=1bd03cd8&scoped=true"
import script from "./orderYbList.vue?vue&type=script&lang=js"
export * from "./orderYbList.vue?vue&type=script&lang=js"
import style0 from "./orderYbList.vue?vue&type=style&index=0&id=1bd03cd8&prod&scoped=true&lang=css"
import style1 from "./orderYbList.vue?vue&type=style&index=1&id=1bd03cd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd03cd8",
  null
  
)

export default component.exports